export const movieList=['Interstellar', 'Tenet', 'Shutter Island','Matrix','Fast X']
export const slots=['10 AM','1 PM' , '4 PM','7 PM']
export const seats=['A1','A2','A3','B1','B2','B3','C1','C2','C3']

